import React, { Component } from 'react';
import SearchItem from './SearchItem';

export class SearchItems extends Component {
  render() {
    if (this.props.mySearchItems === true) {
      return this.props.productIds.map(productId => (
        <SearchItem
          key={productId}
          productId={productId}
          userItem={this.props.userItem}
          incrementSofties={this.props.incrementSofties}
          mySearchItems={true}
        />
      ));
    } else {
      return this.props.products.map(product => (
        <SearchItem
          key={product.objectID}
          productId={product.objectID}
          product={product}
          mySearchItems={false}
        />
      ));
    }
  }
}

export default SearchItems;
